module.exports = __webpack_public_path__ + "img/V.45d4df7f.png";